import mixpanel from "@/utils/mixpanel";
import React from "react";

type Element = {
  name: string;
  slug: string;
  iconImage: string;
};
export function lineBar({
  items,
  activeElement,
}: {
  items: Element[];
  activeElement: string;
}) {
  <div className="flex flex-row h-[1px]">
    {items.map((item: Element) => {
      return (
        <div
          className={`w-[${(100 / items.length) * 100}%] ${
            item.slug == activeElement ? "bg-[#FFD700]" : "bg-[#757575]"
          }`}
        ></div>
      );
    })}
  </div>;
}
export default function AccessBar({
  items,
  activeItem,
  setActiveIcon,
  masterclassTitle,
}: {
  items: Element[];
  activeItem: string;
  setActiveIcon: React.Dispatch<string>;
  masterclassTitle?: string;
}) {
  return (
    <div className="flex flex-col  justify-between items-center w-full">
      <div className="flex flex-row items-center justify-between w-full">
        {items.map((item: Element) => {
          return (
            <div
              className="flex flex-col items-center justify-center w-full"
              onClick={() => {
                setActiveIcon(item.slug);
                mixpanel.track(`masterclass_${activeItem}`, {
                  masterclass: masterclassTitle,
                });
              }}
            >
              <div className="flex flex-row justify-center items-center w-full ">
                <img src={item.iconImage} alt="" />
                <p
                  className={` font-lato text-[16px] md:text-[22px] hover:cursor-pointer ${
                    activeItem === item.slug
                      ? "text-[#9A7026]"
                      : "text-[#757575]"
                  }`}
                >
                  {item.name}
                </p>
              </div>
              <div></div>
              <div
                className={`h-[1px] rounded-full w-full transition-all duration-200 ease-in-out ${
                  item.slug == activeItem ? " bg-[#9A7026]" : ""
                }`}
              ></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
